export default "__VITE_ASSET__0IhYK2FZ__"